<ng-container *ngIf="show">
    <mat-progress-bar
        [color]="'accent'"
        [mode]="mode"
        [value]="progress"></mat-progress-bar>
</ng-container>
